import { t } from 'i18next'

import * as yup from 'yup'

/**
 * Form constants
 */

const SUBMISSION_DESCRIPTION = 'submission_description'
const MATERIALS = 'submission_materials'
const ATTACHMENTS = 'attachments'
const DUE_DATETIME = 'due_datetime'
const EFFECTIVE_DATETIME = 'effective_datetime'

/**
 * Form model
 */
const formModel = () => {
  return {
    [SUBMISSION_DESCRIPTION]: {
      label: `${t('common.description')}`,
      name: SUBMISSION_DESCRIPTION,
      required: true
    },
    [MATERIALS]: {
      label: `${t('common.materials')}`,
      name: MATERIALS,
    },
    [ATTACHMENTS]: {
      label: `${t('common.attachments')}`,
      name: ATTACHMENTS,
    },
    [DUE_DATETIME]: {
      label: `${t('assignments.deadline')}`,
      name: DUE_DATETIME,
    },
    [EFFECTIVE_DATETIME]: {
      label: `${t('assignments.assigned-on')}`,
      name: EFFECTIVE_DATETIME,
    },
  }
}

/**
 * Form initial data
 */
export const initialValues = {
  [MATERIALS]: [],
  [SUBMISSION_DESCRIPTION]: '',
  [DUE_DATETIME]: '',
  [EFFECTIVE_DATETIME]: '',
}

/**
 * Form data validation
 */
export const validationSchema = (userRole: string) =>
  yup.object().shape({
    [SUBMISSION_DESCRIPTION]: yup.string(),
  })

export default formModel
